<div class="header">
  <div class="head-main row">
    <div class="col-6 social">
      <a target="_blank" class="icon" appSocialLink="instagram"><i class="icon-instagram"></i></a>
      <a target="_blank" class="icon" appSocialLink="facebook"><i class="icon-facebook"></i></a>
      <a target="_blank" class="icon" appSocialLink="youtube"><i class="icon-youtube"></i></a>
      <a target="_blank" class="icon" appSocialLink="twiter" style="margin-top: -3px;">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
          class="bi bi-twitter-x" viewBox="0 0 16 16">
          <path
            d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z" />
        </svg>
      </a>
      <a target="_blank" class="icon" appSocialLink="pinterest"><i class="icon-pinterest2"></i></a>
      <a target="_blank" class="icon" appSocialLink="linkedin"><i class="icon-linkedin2"></i></a>
  </div>
  <div class="col-6 user">
    <div [hidden]="!isUserCredentialProviderAcquiring || loginUser?.UserName" class="message">loading...</div>
    <div routerLink="/account/order-shoppingcart" class="cart" [appUserRoleAccessibility]="{userRole:'Dealer,Designer', display:'flex'}"><i class="icon-Cart"></i><span class="number">{{shoppingCartCount}}</span><span>cart</span></div>
    <div [hidden]="isUserCredentialProviderAcquiring" class="login">
      <div *ngIf="!loginUser?.UserName" style="position: relative;top: -5px;"><i class="icon-user"></i><span>my<i>TA</i></span></div>
      <div style="display: flex">
        <div *ngIf="!loginUser?.UserName" class="" appLoginPopup><i class="icon-circle"></i><a>login<i>/</i></a></div>
        <div *ngIf="!loginUser?.UserName" class=""><a appRegisterPopup>sign up</a></div>        
      </div>
    </div>
    <div *ngIf="loginUser?.UserName" class="welcome">
      <i class="icon-user"></i> Welcome, <span class="name"><b>{{loginUser.FirstName}}</b></span>
        <div class="menu">
          <a routerLink="/account/account-profile"><i class="icon-user"></i><span>Account Settings</span></a>
          <a [appUserRoleAccessibility]="{userRole:'Consumer,Sales Associate,Designer,Dealer', display:'block'}" routerLink="/account/account-setting"><i class="icon-setting"></i>Your Settings</a>
          <a routerLink="/account/account-wishlist"><i class="icon-heart_outline"></i>Wish Lists</a>
          <a [appUserRoleAccessibility]="{userRole: 'Dealer,Designer', display:'block'}" routerLink="/account/account-order"><i class="icon-Oder_History"></i>Order Backlog</a>
          <a (click)="logout()"><i class="icon-log_out"></i>Log Out</a>
        </div>
    </div>
    <div class="mode" [appUserRoleAccessibility]="{userRole: 'Dealer,Designer', display:'flex'}">
      <app-ta-mat-slide-toggle-module></app-ta-mat-slide-toggle-module>
    </div>
  </div>
  </div>
</div>


